export default "__VITE_ASSET__C5GI96Tg__"